import { useState } from "react";

const chips = ["综艺瓜", "影视瓜", "热搜瓜", "塌房预警"];

interface Props {
  onSearch: (keyword: string) => void;
}

export default function Hero({ onSearch }: Props) {
  const [kw, setKw] = useState("");

  const submit = (value: string) => {
    onSearch(value.trim());
    document.getElementById("field")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative flex min-h-[640px] items-center overflow-hidden pt-16 md:min-h-[720px]"
    >
      <img
        src="https://readdy.ai/api/search-image?query=A%20playful%20editorial%20illustration%20of%20a%20giant%20watermelon%20melon%20slices%20and%20juicy%20red%20drops%20floating%20among%20soft%20speech%20bubbles%20and%20comment%20streaming%20threads%2C%20warm%20watermelon%20coral%20red%20and%20melony%20green%20on%20a%20soft%20cream%20canvas%2C%20flat%20modern%20digital%20art%2C%20subtle%20depth%2C%20cozy%20and%20energetic%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=chigua-hero-2026&orientation=landscape"
        alt="吃瓜吧瓜田风格的抽象插画背景，西瓜与气泡留言元素"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-primary-950/55 via-foreground-950/35 to-accent-900/45" />

      <div className="relative z-10 mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/90 px-4 py-1.5 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            今日瓜田正在更新中 · 楼层实时跟进
          </span>

          <h1 className="mt-6 text-4xl leading-tight text-background-50 md:text-6xl">
            盖楼蹲帖 · 追连瓜不掉线
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-background-100/90 md:text-lg">
            吃瓜吧把正在发生的瓜整理成一条条可蹲的楼层，持续吃瓜、楼层跟进新进展，和瓜友一起等后续，更新随时顶上来。
          </p>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              submit(kw);
            }}
            className="mt-8 flex max-w-lg flex-col gap-3 sm:flex-row"
            role="search"
            aria-label="搜索正在蹲的瓜"
          >
            <label className="flex flex-1 items-center gap-2 rounded-full bg-background-50/95 px-4 py-1">
              <i className="ri-search-line text-lg leading-none text-foreground-400" />
              <input
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                type="text"
                placeholder="搜一搜今天蹲的瓜，如：舞台请就位"
                className="w-full bg-transparent py-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </label>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              去蹲帖
            </button>
          </form>

          <div className="mt-7 flex flex-wrap items-center gap-2">
            <span className="text-sm text-background-100/80">热门：</span>
            {chips.map((c) => (
              <button
                key={c}
                onClick={() => submit(c)}
                className="whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-50 backdrop-blur transition-colors hover:bg-background-50/25"
              >
                {c}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}